"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vue2Editor = require("vue2-editor");
var _elementUi = require("element-ui");
var _log = require("@/utils/log");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cookie = require("@/utils/cookie");
var _utils = require("@/utils");
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
var _index = _interopRequireDefault(require("../../../../components/EventTime/index.vue"));
var _subscriptions = require("@/api/subscriptions");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const tmpHikeGeninfo = {};
// const defaultValue = []
var _default = exports.default = {
  name: 'HikeGeninfo',
  components: {
    VueEditor: _vue2Editor.VueEditor,
    EventTime: _index.default
  },
  props: {
    parentHike: {
      type: Object,
      default: tmpHikeGeninfo
    },
    parentRelatedLoops: {
      type: Array,
      default: () => []
    },
    relatedLoopsLoading: {
      type: Boolean,
      default: false
    },
    displayType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      customToolbar: [['bold'], [{
        list: 'bullet'
      }]],
      loading: false,
      timeZoneList: _lifehikesInitData.ianaTimeZone,
      countryList: [],
      tagInputVisible: false,
      /* use for Tag component */
      tagInputValue: '',
      /* use for tag component */
      hike: {},
      HikeCategory: _lifehikesInitData.HikeCategory,
      loggedInUserTenants: [],
      subscriptionsList: [],
      subscriptionsLoading: false
    };
  },
  watch: {
    hike: {
      handler(newVal) {
        this.passBackGenInfo(newVal);
      },
      deep: true
    },
    parentRelatedLoops: {
      immediate: true,
      handler(loops) {
        this.subscriptionsList = [];
        const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
        if (!token || !Array.isArray(loops) || loops.length === 0) return;
        const subIds = new Set();
        loops.forEach(loop => {
          if (loop.metadata && loop.metadata.subscriptionId) {
            subIds.add(loop.metadata.subscriptionId);
          }
        });
        const uniqueSubIds = Array.from(subIds);
        if (uniqueSubIds.length === 0) return;
        this.subscriptionsLoading = true;
        let pending = uniqueSubIds.length;
        uniqueSubIds.forEach(subId => {
          (0, _subscriptions.getSubscriptionById)(token, subId).then(subResponse => {
            if (subResponse.data && subResponse.data.title) {
              if (!this.subscriptionsList.some(s => s.id === subId)) {
                this.subscriptionsList.push({
                  id: subId,
                  title: subResponse.data.title
                });
              }
            }
          }).catch(error => {
            (0, _log.showDebugLog)('HikeGeninfo-getSubscriptionById-error', error);
            if (!this.subscriptionsList.some(s => s.id === subId)) {
              this.subscriptionsList.push({
                id: subId,
                title: 'Subscription: ' + subId
              });
            }
          }).finally(() => {
            pending--;
            if (pending === 0) this.subscriptionsLoading = false;
          });
        });
      }
    }
  },
  created() {
    this.hike = this.parentHike;
    this.$store.dispatch('facets/getInitData', 'en').then(() => {
      this.countryList = this.$store.getters.countries;
    });
    const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
    if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
      this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
    }
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    openSubscription(id) {
      window.open(`/#/subscriptions/edit/${id}`, '_blank');
    },
    openLoop(id) {
      window.open(`/#/loop/edit/${id}`, '_blank');
    },
    copyPostProgramFeedbackSurveyLandingPageLink() {
      navigator.clipboard.writeText(this.hike.postProgramFeedbackSurveyLandingPageUrl);
      _elementUi.Message.info('Copied to Clipboard');
    },
    openPostProgramFeedbackSurveyLandingPage() {
      window.open(this.hike.postProgramFeedbackSurveyLandingPageUrl, '_blank');
    },
    prefillFeedbackLink() {
      this.hike.feedbackUrl = `https://otr.link/${this.hike.internal.opportunityNumber}`;
    },
    passBackGenInfo(myHike) {
      this.$emit('updateParentGenInfo', myHike);
    },
    handleTagInputConfirm() {
      const inputValue = this.tagInputValue;
      if (inputValue && this.hike.tags.indexOf(inputValue) < 0) {
        this.hike.tags.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.hike.tags.splice(this.hike.tags.indexOf(tag), 1);
    },
    showUTCDate(utcDate) {
      // 'YYYY-MM-DD HH:mm:ss [GMT]Z[ (]z[)]'
      // 'YYYY-MM-DD HH:mm:ss (zZ)'
      return (0, _momentTimezone.default)(utcDate).utc().format('YYYY-MM-DD HH:mm:ss (z+0)');
    }
  }
};